import trainers from '@/store/modules/trainers/trainers'
import createTrainer from '@/store/modules/trainers/trainer-create'
import editTrainer from '@/store/modules/trainers/trainer-edit'
import trainersGroup from '@/store/modules/trainers/trainers-group'
import trainersIsBlocked from '@/store/modules/trainers/trainer-is-blocked'

export default {
  trainers,
  createTrainer,
  editTrainer,
  trainersGroup,
  trainersIsBlocked,
}
